/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  ImagesControllerProxyQueryResponse,
  ImagesControllerProxyQueryParams,
} from '../types/ImagesControllerProxy.ts';

function getImagesProxyUrl() {
  const res = { method: 'GET', url: `/api/images/proxy` as const };
  return res;
}

/**
 * {@link /api/images/proxy}
 */
export async function imagesProxy(
  params: ImagesControllerProxyQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<ImagesControllerProxyQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getImagesProxyUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
